// extracted by mini-css-extract-plugin
export default {"header":"Header_header__50fjH","navbar":"Header_navbar__SD7ol","navbar__item":"Header_navbar__item__wIg+8","auth":"Header_auth__wT4RE"};